@let showDropdown = dropdownEnabled() && searchSuggestions() && searchSuggestions()!.length > 0 && isDropdownOpen();
<div class="relative flex flex-col gap-y-1">
  <span class="mb-1 font-bold">{{ "COMPONENT.SEARCH.LABEL_MY_CITY" | translate }}</span>
  <div class="relative">
    <input
      (keydown.enter)="submitSearch()"
      [formControl]="searchControl"
      [ngClass]="{
        'rounded-t-[10px]': showDropdown,
        'rounded-[10px] border': !showDropdown,
      }"
      [placeholder]="placeholder()"
      class="w-full border-x border-t px-3.5 py-3 pr-10 focus-visible:outline-none"
      type="text" />
    <div (click)="submitSearch()" class="absolute right-3 top-2.5 cursor-pointer">
      <app-svg [height]="22" src="assets/icons/search.svg" />
    </div>
  </div>
  @if (showDropdown) {
    <ul class="absolute top-[67px] z-10 flex w-full flex-col overflow-hidden rounded-b-[10px] border bg-white">
      @for (option of searchSuggestions(); track option.key) {
        <li class="cursor-pointer px-3.5 py-3 hover:bg-gray-light" (click)="selectSuggestion(option)">
          {{ option.label }}
        </li>
      }
    </ul>
  }
  @if (this.isMinLengthError()) {
    <span class="absolute -bottom-5 text-[10px] text-error">{{ "GLOBAL.FIELD_MIN_LENGTH_ERROR" | translate }}</span>
  }
</div>
